import React, {Component} from 'react';
import FJSlider from 'fj-components/FJSlider';
import classNames from 'classnames';
import PropTypes from 'prop-types'
import styles from './FJSliderPlay.module.less';
import {connect} from "react-redux";

class FJSliderPlay extends Component {

    render() {
        let {
            currentTime,
            duration,
            onBeforeChange,
            onChange,
            onAfterChange,
            disabled,
            classes,
        } = this.props;
        let progress  = currentTime/duration;
        let sliderClasses = {
            sliderBoxClassName: classNames(styles.play_edit, classes.sliderBoxClassName),
            railClassName: classNames(styles.rail, classes.railClassName),
            trackClassName: classNames(styles.track, classes.trackClassName),
            handleClassName: classNames(styles.handle, classes.handleClassName),
            handleDisabledClassName: classNames(styles.disable, classes.disableClassName)
        };
        return (
            <div className={styles.play_box}>
                <FJSlider progress={progress}
                          onBeforeChange={onBeforeChange}
                          onChange={onChange}
                          onAfterChange={onAfterChange}
                          disabled={disabled}
                          classes={sliderClasses}
                />
            </div>
        );
    }
}

FJSliderPlay.propTypes = {
    classes: PropTypes.object
};

FJSliderPlay.defaultProps = {
    classes: {
        sliderBoxClassName: '',
        railClassName: '',
        trackClassName: '',
        handleClassName: '',
        disableClassName: ''
    }
};

const mapStateToProps = function (state) {
    return {
        currentTime: state.timeline.currentTime,
        duration: state.timeline.duration,
    }
};

const mapDispatchToProps = function (dispatch) {
    return {
    }
};

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(FJSliderPlay);
